import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ProposalProjectExternalCost } from "../Model/ProposalProjectExternalCost";


export async function patchProposalProjectExternalCost(data) {	
	let response = await getAPIResponse("/v1/proposal-project-external-cost", data, "PATCH");
	if (response === null) {
		return null;
	}
	let proposalProjectExternalCost = [];
	response.forEach((responseData) => {
		proposalProjectExternalCost.push(ProposalProjectExternalCost.createFromResponseData(responseData));
	});
	return proposalProjectExternalCost;
}